import {
    EllipsisTextColumn,
    FlexGrow,
    ListContentWrap,
    PageArticleWrap,
    PageHeaderTitleButtonStyle,
} from "components/layout/Layout";
import React, { useEffect, useState} from "react";
import {NoDataWithImageText} from "components/NoDataComponent";
import {
    OutlinePrimaryBtn,
    SolidPrimaryBtn,
    SolidPrimarySubBtn,
    SolidRedBtn
} from "components/button/Button";
import styled from "styled-components";
import refreshIcon from "assets/image/common/refresh.svg";
import {
    DeviceInfo,
    DeviceRequestType,
    ListResult, SingleResult,
    StudentInfo,
    SyncStudentDeviceRequestType
} from "../../type/type";
import {
    createDeviceHandler,
    getDeviceListHandler,
    getImageUrl,
    getStudent, removeDeviceHandler, removeStudentHandler, syncStudentDeviceHandler,
    updateDeviceHandler
} from "../../api/api";
import {CustomCheckbox} from "components/input/Input";
import {aesCBCDecrypt, ellipsisText, NoDeviceDataText, NoStudentDataText} from "../../utils/commonUtils";
import DefaultProfileS from "assets/image/common/default_profile_S.svg";
import {
    DefaultModalComponent,
    ModalPropsInterface, ModalTitle, ModalType
} from "components/ModalComponent";
import {RoundImage} from "components/common/Image";
import { InputWrapC } from "components/common/CommonLayout";
import Loading from "components/Loading";
import { useRecoilValue } from "recoil";
import { selectSiteIdState } from "styles/atoms";

const InputWrap = styled.div`
  width: 100%;
  display: flex;
`;
const FlexRowCenter = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;
const JoinNavWrap = styled.nav`
    display:flex;
    gap: 1rem;
    flex-direction: row;
    align-items: center;
`
const TableColumn = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${({theme}) => theme.newTheme.border.primaryBd};
  > div {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem 1rem;
  }
  .thumbnail-wrap {
    max-height: 5rem;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  &:hover {
    background-color: ${({theme}) => theme.newTheme.table.tableBodyHoverBg};
  }
`;

interface DeviceListViewerProps {
    deviceList: DeviceInfo[];
    openModal: (modalType: ModalType) => void;
    changeDeviceId: (id: number) => void; //수정 or 삭제를 클릭한 디바이스 ID
    changeRequestDevice: (deviceInfo:DeviceInfo) => void;
    deviceCheckAll: boolean;
    deviceCheckIdList: number[];
    handleDeviceCheck: (deviceId: number) => void;
    handleDeviceAll: () => void;
    removeDevice: (deviceId:number) => void;

}

/**
 * 디바이스 테이블 항목 그리기
 * @param deviceList
 * @param openModal
 * @param changeDeviceId
 * @param changeRequestDevice
 * @param deviceCheckAll
 * @param deviceCheckIdList
 * @param handleDeviceAll
 * @param handleDeviceCheck
 * @param removeDevice
 * @constructor
 */
const DeviceListViewer:React.FC<DeviceListViewerProps> = ({deviceList,
                                                              openModal,
                                                              changeDeviceId,
                                                              changeRequestDevice,
                                                              deviceCheckAll,
                                                              deviceCheckIdList,
                                                              handleDeviceAll,
                                                              handleDeviceCheck,
                                                              removeDevice}) => {


    return (
        <div className="list-table">
            <div>
                <nav className="list-table-header">
                    <FlexRowCenter className="w-8">
                        <CustomCheckbox type="checkbox"
                                        checked={deviceCheckAll}
                                        onClick={handleDeviceAll}/>
                    </FlexRowCenter>
                    <FlexGrow className="w-10">명칭</FlexGrow>
                    <FlexGrow className="w-12">IP 주소</FlexGrow>
                    <div className="w-8">SDK 포트</div>
                    <div className="w-8">웹 포트</div>
                    <FlexGrow className="w-12">MAC 주소</FlexGrow>
                    <div className="w-10">연결 상태</div>
                    <div className="w-12"></div>
                </nav>
                {deviceList.map((device: DeviceInfo) => (
                    <TableColumn key={device.id}>
                        <FlexRowCenter className="w-8">
                            <CustomCheckbox type="checkbox"
                                            value={device.id}
                                            checked={deviceCheckIdList.includes(device.id)}
                                            onChange={() => handleDeviceCheck(device.id)}/>
                        </FlexRowCenter>
                        <FlexGrow className="w-10">
                            <EllipsisTextColumn>{device.name}</EllipsisTextColumn>
                        </FlexGrow>
                        <FlexGrow className="w-12">
                            <EllipsisTextColumn>{device.ip_address}</EllipsisTextColumn>
                        </FlexGrow>
                        <div className="w-8">{device.sdk_port}</div>
                        <div className="w-8">{device.web_port}</div>
                        <FlexGrow className="w-12">
                            <EllipsisTextColumn>{device.mac_address}</EllipsisTextColumn>
                        </FlexGrow>
                        <div className="w-10">
                            {device.connect_status ? (<span className="text-green">연결</span>) : (
                                <span className="text-red">연결되지 않음</span>)}
                        </div>
                        <div className="w-12" style={{gap: "0.5rem"}}>
                            <SolidPrimarySubBtn className="little-btn" onClick={() => {changeDeviceId(device.id);changeRequestDevice(device); openModal('deviceModify');}}>수정</SolidPrimarySubBtn>
                            <SolidRedBtn className="little-btn" onClick={() => {removeDevice(device.id)}}>삭제</SolidRedBtn>
                        </div>
                    </TableColumn>
                ))}
            </div>
        </div>
    );
}


interface StudentListViewerProps {
    studentList: StudentInfo[];
    studentIdCheckList: number[];
    studentCheckAll: boolean;
    syncLoading: boolean;
    handleStudentAll: () => void;
    handleStudentCheck: (studentId: number) => void;
    removeStudent: (studentId:number) => void;
}

/**
 * 원생 테이블 항목 그리기
 * @param studentList
 * @constructor
 */
const StudentListViewer:React.FC<StudentListViewerProps> = ({studentList,
                                                            studentCheckAll,
                                                            studentIdCheckList,
                                                            syncLoading,
                                                            handleStudentCheck,
                                                            handleStudentAll,
                                                            removeStudent}) => {
    const [studentsWithImages, setStudentsWithImages] = useState<(StudentInfo & { image: string })[]>([]);


    //모든 학생 이미지 파일 가져오기
    const fetchImages = async () => {
        const studentsWithImagePromises = studentList.map(async (student: StudentInfo) => {
            const image = (student.image_list.length > 0 && student.image_list[0].file_size) ? getImageUrl(student.image_list[0].file_name) : DefaultProfileS;
            return { ...student, image };
        });

        const studentsWithImages = await Promise.all(studentsWithImagePromises);
        setStudentsWithImages(studentsWithImages);
    };
    useEffect(() => {
        fetchImages();
    }, [studentList]);

    return (
        <div className="list-table">
            <div>
                <nav className="list-table-header">
                    <FlexRowCenter className="w-5">
                        <CustomCheckbox type="checkbox"
                                        checked={studentCheckAll}
                                        onClick={handleStudentAll}/>
                    </FlexRowCenter>
                    <div className="w-12">사진</div>
                    <FlexGrow className="w-12">학생 이름</FlexGrow>
                    <FlexGrow className="w-12">반</FlexGrow>
                    <FlexGrow className="w-15">학부모</FlexGrow>
                    <div className="w-15">생년월일</div>
                    <div className="w-10">동기화 상태</div>
                    <div className="w-10"></div>
                </nav>
                {syncLoading ? <Loading />
                    : studentsWithImages.map((student: StudentInfo & { image: string }) => {

                        if(student.is_delete === 1) return null;

                        const className = student.class_list && student.class_list.length > 0 ? student.class_list[0].name : "";
                        const birthDate = student.birth_date
                            ? `${student.birth_date.substring(0, 4)}년 ${student.birth_date.substring(5, 7)}월 ${student.birth_date.substring(8, 10)}일`
                            : "";
                        return (
                            <TableColumn key={student.id}>
                                <FlexRowCenter className="w-5">
                                    <CustomCheckbox type="checkbox"
                                                    value={student.id}
                                                    checked={studentIdCheckList.includes(student.id)}
                                                    onChange={() => handleStudentCheck(student.id)}/>
                                </FlexRowCenter>
                                <div className="w-12">
                                    <RoundImage srcSet={student.image} alt="profile"/>
                                </div>
                                <FlexGrow className="w-12">
                                    <EllipsisTextColumn>{aesCBCDecrypt(student.name)}</EllipsisTextColumn>
                                </FlexGrow>
                                <FlexGrow className="w-12">
                                    <EllipsisTextColumn>{className}</EllipsisTextColumn>
                                </FlexGrow>
                                <FlexGrow className="w-15">
                                    {student.parent_list.map((p, index) => 
                                        index === 0 &&
                                        <EllipsisTextColumn>{ellipsisText(aesCBCDecrypt(p.user_name), 6) || ""}{p.relation && `(${ellipsisText(p.relation, 5)})`}</EllipsisTextColumn>

                                    )}
                                </FlexGrow>
                                <div className="w-15">{birthDate}</div>
                                <div className="w-10">
                                    {student.sync_device_status === 1 ? (<span className="text-green">완료</span>) : (
                                        <span className="text-red">미완료</span>)}
                                </div>
                                <div className="w-10" style={{gap: "0.5rem"}}>
                                    <SolidRedBtn className="little-btn" onClick={() => {
                                        removeStudent(student.id);
                                    }}>삭제</SolidRedBtn>
                                </div>
                            </TableColumn>
                        );
                    })}
            </div>
        </div>
        
    )
}


export const Attendance = () => {

    // 전역 데이터
    const selectSiteId = useRecoilValue(selectSiteIdState);
    
    const [loading, setLoading] = useState(false);
    const [syncLoading, setSyncLoading] = useState(false);
    const [deviceList, setDeviceList] = useState<DeviceInfo[]>([]);
    const [studentList, setStudentList] = useState<StudentInfo[]>([]);
    const [modalProps, setModalProps] = useState<ModalPropsInterface>({
        isOpen: false,
        isClose: () => {},
        title: "",
        content: null,
        button: null,
        type: ""
    });

    //원생 상태값 시작
    const [studentIdCheckList, setStudentIdCheckList] = useState<number[]>([]);
    const [studentCheckAll, setStudentCheckAll] = useState<boolean>(false);

    /**
     * 단말기 관련 함수,상태값 시작
     */
    //수정을 클릭한 디바이스 ID
    const [deviceClickId, setDeviceClickId] = useState<number>(0);
    const [deviceCheckAll, setDeviceCheckAll] = useState<boolean>(false);
    const [deviceCheckIdList, setDeviceCheckIdList] = useState<number[]>([]);
    //단말기 등록/수정 정보
    const [requestDevice, setRequestDevice] = useState<DeviceRequestType>({
        site_id: selectSiteId,
        name: "",
        ip_address: "",
        product_code: 1,
        auth_id:"",
        auth_pw:"",
        sdk_port: 0,
        web_port: 80,
        tcp_port: 80,
        call_port: 0,
    });


    // 전체 선택 체크박스 핸들러
    const handleDeviceAll = () => {
        if (deviceCheckAll) {
            setDeviceCheckIdList([]); // 전체 선택 해제 시 빈 배열
        }
        else {
            const allDeviceIds = deviceList.map(device => Number(device.id));
            setDeviceCheckIdList(allDeviceIds); // 전체 선택 시 모든 디바이스 ID 저장
        }
        setDeviceCheckAll(!deviceCheckAll); // 전체 선택 상태 업데이트
    };

    // 개별 체크박스 핸들러
    const handleDeviceCheck = (deviceId: number) => {
        if (deviceCheckIdList.includes(deviceId)) {
            setDeviceCheckIdList(deviceCheckIdList.filter(id => Number(id) !== Number(deviceId))); // 이미 선택된 디바이스 해제
        } else {
            setDeviceCheckIdList([...deviceCheckIdList, deviceId]); // 새로 선택된 디바이스 추가
        }
    };


    function changeDeviceId(id: number){
        setDeviceClickId(id);
    }

    function changeRequestDevice(deviceInfo:DeviceInfo){
        setRequestDevice({
            site_id: deviceInfo.site_id,
            name: deviceInfo.name,
            ip_address: deviceInfo.ip_address,
            product_code: deviceInfo.product_code,
            auth_id: deviceInfo.auth_id,
            auth_pw: aesCBCDecrypt(deviceInfo.auth_pw),
            sdk_port: deviceInfo.sdk_port,
            web_port: deviceInfo.web_port,
            tcp_port: deviceInfo.tcp_port,
            call_port: deviceInfo.call_port,
        })
    }
    //requestDevice 값 초기화
    function initRequestDevice(){
        setRequestDevice({
            site_id: selectSiteId,
            name: "",
            ip_address: "",
            product_code: 1, //HIK만 가능
            auth_id:"",
            auth_pw:"",
            sdk_port: 0,
            web_port: 80,
            tcp_port:80,
            call_port: 0,
        })
    }


    function ChangeInputDevice(e: React.ChangeEvent<HTMLInputElement>) {
        const { name, value } = e.target;

        setRequestDevice((prevRequestDevice) => ({
            ...prevRequestDevice,
            [name]: name === "product_code" ? Number(value) : value,
        }));
    }

    //디바이스 등록 모달 컨텐츠
    function deviceModalContent(): JSX.Element {
        return (
            <InputWrapC>
                {/*<InputWrap>*/}
                {/*    <InputWrapC>*/}
                {/*        <label>단말기 종류</label>*/}
                {/*        <div style={{display:"flex",padding:"0.3rem"}}>*/}
                {/*            <label style={{width:"50%"}}>*/}
                {/*                <div>HIK</div>*/}
                {/*                <input type="radio" name="product_code" value="1" onChange={ChangeInputDevice}*/}
                {/*                       checked={requestDevice.product_code === 1}/>*/}
                {/*            </label>*/}
                {/*            <label style={{width:"50%"}}>*/}
                {/*                <div>HEOP</div>*/}
                {/*                <input type="radio" name="product_code" value="2" onChange={ChangeInputDevice}*/}
                {/*                       checked={requestDevice.product_code === 2}/>*/}

                {/*            </label>*/}
                {/*        </div>*/}
                {/*    </InputWrapC>*/}
                {/*</InputWrap>*/}
                <InputWrap>
                    <InputWrapC>
                        <label className="required_value">명칭</label>
                        <input type="text" name="name" onChange={ChangeInputDevice} value={requestDevice.name} placeholder="현관 출결 기기" />
                    </InputWrapC>
                </InputWrap>

                <InputWrap>
                    <InputWrapC>
                        <label className="required_value">IP 주소</label>
                        <input type="text" name="ip_address" onChange={ChangeInputDevice} value={requestDevice.ip_address} placeholder="IP 주소 입력" />
                    </InputWrapC>
                </InputWrap>
                <InputWrap>
                    <InputWrapC>
                        <label className="required_value">SDK 포트</label>
                        <input type="number" name="sdk_port" onChange={ChangeInputDevice} value={requestDevice.sdk_port} placeholder="SDK 포트 입력" />
                    </InputWrapC>
                </InputWrap>
                <InputWrap>
                    <InputWrapC>
                        <label className="required_value">웹 포트</label>
                        <input type="number" name="web_port" onChange={ChangeInputDevice} value={requestDevice.web_port} placeholder="웹 포트 입력"/>
                    </InputWrapC>
                </InputWrap>
                <InputWrap>
                    <InputWrapC>
                        <label>영상 포트</label>
                        <input type="number" name="call_port" onChange={ChangeInputDevice} value={requestDevice.call_port} placeholder="영상포트 입력(필수 아님)"/>
                    </InputWrapC>
                </InputWrap>
                <InputWrap>
                    <InputWrapC>
                        <label className="required_value">접속 아이디</label>
                        <input type="text" name="auth_id" onChange={ChangeInputDevice} value={requestDevice.auth_id} placeholder="아이디 입력"/>
                    </InputWrapC>
                </InputWrap>
                <InputWrap>
                    <InputWrapC>
                        <label className="required_value">접속 비밀번호</label>
                        <input type="password" name="auth_pw" onChange={ChangeInputDevice} value={requestDevice.auth_pw} placeholder="비밀번호 입력"/>
                    </InputWrapC>
                </InputWrap>
            </InputWrapC>
        )
    }
    //디바이스 등록 모달 컨텐츠
    function deviceModalButton(): JSX.Element {
        return (
            <>
                {
                    modalProps.type === "deviceCreate" ?
                        (<SolidPrimaryBtn onClick={validateDeviceForm} style={{width:"100%"}}>
                            저장
                        </SolidPrimaryBtn>)
                        :
                        (<SolidPrimaryBtn onClick={validateDeviceForm} style={{width:"100%"}}>
                            수정
                        </SolidPrimaryBtn>)
                }
            </>
        )
    }

    //폼 유효성 검사
    function validateDeviceForm() {
        if(requestDevice.site_id === 0){
            requestDevice.site_id = selectSiteId;
        }

        if(requestDevice.product_code === 0){
            alert("단말기 종류를 선택해주세요");
            return;
        }

        if(requestDevice.name === ""){
            alert("명칭을 입력해주세요");
            return;
        }

        if(requestDevice.ip_address === ""){
            alert("IP 주소를 입력해주세요");
            return;
        }

        if(requestDevice.sdk_port === 0){
            alert("SDK 포트를 입력해주세요");
            return;
        }

        if(requestDevice.web_port === 0){
            alert("웹 포트를 입력해주세요");
            return;
        }

        if(requestDevice.auth_id === ""){
            alert("접속 아이디를 입력해주세요");
            return;
        }

        if(requestDevice.auth_pw === ""){
            alert("접속 비밀번호를 입력해주세요");
            return;
        }

        modalProps.type === "deviceCreate" ? createDevice() : updateDevice();

        //디바이스 등록 요청
        async function createDevice(){
            try{
                const response = await createDeviceHandler(requestDevice);

                if(response.code === 200){
                    alert("기기 등록이 완료되었습니다.");
                    setModalProps({...modalProps, isOpen: false});
                }
                else{
                    alert("기기 등록 중 오류가 발생하였습니다.");
                }
            }
            catch(e){
                console.error(e);
                alert("기기 등록 중 오류가 발생하였습니다.");
            }
            finally {
                getDeviceList();
            }
        }

        //디바이스 수정 요청
        async function updateDevice(){
            try{
                const response = await updateDeviceHandler(deviceClickId,requestDevice);

                if(response.code === 200){
                    alert("기기 수정이 완료되었습니다.");
                    setModalProps({...modalProps, isOpen: false});
                }
                else{
                    alert("기기 수정 중 오류가 발생하였습니다.");
                }

            }
            catch(e){
                console.error(e);
            }
            finally {
                getDeviceList();
            }
        }
    }

    async function removeDevice(deviceId:number){
        try{
            const confirmResult = window.confirm("기기를 삭제하시겠습니까?");
            if(!confirmResult){
                return;
            }
            //삭제 요청
            const response = await removeDeviceHandler(deviceId);

            if(response.code === 200){
                alert("기기 삭제가 완료되었습니다.");
            }
            else{
                alert("기기 삭제 중 오류가 발생하였습니다.");
            }

        }
        catch(e){
            console.error(e);
            alert("기기 삭제 중 오류가 발생하였습니다.");
        }
        finally {
            getDeviceList();
        }
    }

    async function removeDeviceAll(){
            try{
                if(deviceCheckIdList.length === 0){
                    alert("삭제할 기기를 선택해주세요.");
                    return;
                }

                const confirmResult = window.confirm("선택한 기기를 삭제하시겠습니까?");
                if(!confirmResult){
                    return;
                }

                const responseList = deviceCheckIdList.map(async (deviceId) => {
                    //삭제 요청
                    await removeDeviceHandler(deviceId);
                });

                const response = await Promise.all(responseList);
                if(response.length === deviceCheckIdList.length){
                    alert("기기 삭제가 완료되었습니다.");
                }
                else{
                    alert("기기 삭제 중 오류가 발생하였습니다.");
                }
            }
            catch(e){
                console.error(e);
                alert("기기 삭제 중 오류가 발생하였습니다.");
            }
            finally {
                getDeviceList();
            }
    }
    /**
     * 단말기 관련 함수 끝
     *
     */


    /**
     * 원생 관련 함수 시작
     */
    const handleStudentAll = () => {
        if (studentCheckAll) {
            setStudentIdCheckList([]); // 전체 선택 해제 시 빈 배열
        }
        else {
            const allDeviceIds = studentList.map(student => Number(student.id));
            setStudentIdCheckList(allDeviceIds); // 전체 선택 시 모든 디바이스 ID 저장
        }
        setStudentCheckAll(!studentCheckAll); // 전체 선택 상태 업데이트
    };

    const handleStudentCheck = (studentId: number) => {
        if (studentIdCheckList.includes(studentId)) {
            setStudentIdCheckList(studentIdCheckList.filter(id => Number(id) !== Number(studentId))); // 이미 선택된 학생 해제
        } else {
            setStudentIdCheckList([...studentIdCheckList, studentId]); // 새로 선택된 학생 추가
        }
    };

    async function removeStudent(studentId:number){
        try{
            const confirmResult = window.confirm("원생을 삭제하시겠습니까?");
            if(!confirmResult){
                return;
            }
            //삭제 요청
            const response = await removeStudentHandler(studentId);

            if(response.code === 200){
                alert("원생 삭제가 완료되었습니다.");
            }
            else{
                alert("원생 삭제 중 오류가 발생하였습니다.");
            }

        }
        catch(e){
            console.error(e);
            alert("원생 삭제 중 오류가 발생하였습니다.");
        }
        finally {
            getStudentList();
        }
    }

    async function removeStudentAll(){
        try{
            if(studentIdCheckList.length === 0){
                alert("삭제할 학생을 선택해주세요.");
                return;
            }

            const confirmResult = window.confirm("선택한 학생을 삭제하시겠습니까?");
            if(!confirmResult){
                return;
            }

            const responseList = studentIdCheckList.map(async (studentId) => {
                //삭제 요청
                await removeStudentHandler(studentId);
            });

            const response = await Promise.all(responseList);
            if(response.length === studentIdCheckList.length){
                alert("원생 삭제가 완료되었습니다.");
            }
            else{
                alert("원생 삭제 중 오류가 발생하였습니다.");
            }
        }
        catch(e){
            console.error(e);
            alert("원생 삭제 중 오류가 발생하였습니다.");
        }
        finally {
            getStudentList();
        }
    }
    //학생 동기화
    async function studentDeviceSync() {
        try {

            if(studentIdCheckList.length === 0){
                alert("동기화할 학생을 선택해주세요.");
                return;
            }
    
            const confirmResult = window.confirm("선택한 학생을 동기화하시겠습니까?");
            if(!confirmResult){
                return;
            }
    
            setSyncLoading(true);
    
            const requestData:SyncStudentDeviceRequestType = {
                student_id_list: studentIdCheckList
            }
    
            //동기화 요청
            const response:SingleResult<number[]> = await syncStudentDeviceHandler(requestData);
    
            if(response.code === 200){
                alert("선택한 학생이 동기화되었습니다.");
                getStudentList();
            }
            else {
                alert("학생 동기화 중 오류가 발생하였습니다.");
            }
            
        } catch (error) {
            console.error("error ", error);
        }
        finally {
            setSyncLoading(false);
        }

    }

    /**
     * 원생 관련 함수 끝
     *
     */

    //모달 열기 전 모달에 필요한 정보 설정
    function openModal(modalType: ModalType) {
        let title: ModalTitle = "";
        let content: JSX.Element = <></>;
        let button: JSX.Element = <></>;
        switch (modalType) {
            case "deviceCreate":
                title = "전자 출결 기기 등록";
                content = deviceModalContent();
                break;
            case "deviceModify":
                title = "전자 출결 기기 수정";
                content = deviceModalContent();
                break;
        }

        setModalProps({
            isOpen: true,
            isClose: () => setModalProps({...modalProps, isOpen: false}),
            title: title,
            content: content,
            button: button,
            type: modalType
        });
    }


    //디바이스 목록 가져오기
    async function getDeviceList() {

        try{
            const res:ListResult<DeviceInfo> = await getDeviceListHandler({});
            
            setDeviceList([]);//초기화
            if(res.code === 200){
                setDeviceList(res.data);
            }
        }
        catch(e){
            console.error(e);
        }
        finally {
            setDeviceClickId(0);
            setDeviceCheckAll(false);
            setDeviceCheckIdList([]);
        }
    }

    //학생 목록 가져오기
    async function getStudentList() {
        try {
            setLoading(true);
            
            const res:ListResult<StudentInfo> = await getStudent({});
            setStudentList([]); //초기화
            if(res.code === 200){
                const studentList = res.data.filter((student: StudentInfo) => student.is_delete === 0);
                setStudentList(studentList);
            }
        }
        catch (e) {
            console.error(e);
        }
        finally {
            setLoading(false);
            setStudentIdCheckList([]);
            setStudentCheckAll(false);
        }
    }

    useEffect(() => {
        setLoading(true);
        getDeviceList();
        getStudentList();
    }, []);

    return (
        loading ? (
            <Loading />
        ) : (
        <>
            <PageHeaderTitleButtonStyle>
                <p className="header-title">전자 출결</p>
                <div className="button-wrap">
                    {/* <OutlinePrimaryBtn>불러오기</OutlinePrimaryBtn> */}
                    <SolidPrimaryBtn
                        onClick={() => {openModal("deviceCreate");initRequestDevice();}}>
                        신규 기기 등록
                    </SolidPrimaryBtn>
                </div>
            </PageHeaderTitleButtonStyle>
            <PageArticleWrap>
                <article className="list-content-container" style={{minHeight:"16rem",maxHeight:"16rem"}}>
                    <div className="article-header height-auto">
                        <p>
                            <span className="article-header-title">전자출결 기기 정보({deviceList.length}) </span>
                        </p>
                        <JoinNavWrap>
                            <OutlinePrimaryBtn type="button" className="contain-icon" onClick={getDeviceList}>
                                <img srcSet={refreshIcon} alt="refresh"/>
                                새로고침
                            </OutlinePrimaryBtn>
                            <SolidRedBtn type="button" onClick={removeDeviceAll}>
                                일괄 삭제
                            </SolidRedBtn>
                        </JoinNavWrap>
                    </div>

                    <ListContentWrap style={{height: 'calc(100% - 0.5rem - 2.375rem)'}}>
                        <div className="list-one-wrap h100">
                            {deviceList.length === 0 ? (<NoDataWithImageText text={NoDeviceDataText}/>)
                                : <DeviceListViewer deviceList={deviceList}
                                                    openModal={openModal}
                                                    changeDeviceId={changeDeviceId}
                                                    changeRequestDevice={changeRequestDevice}
                                                    deviceCheckAll={deviceCheckAll}
                                                    deviceCheckIdList={deviceCheckIdList}
                                                    handleDeviceAll={handleDeviceAll}
                                                    handleDeviceCheck={handleDeviceCheck}
                                                    removeDevice={removeDevice}/>}
                        </div>
                    </ListContentWrap>
                </article>

                <article className="list-content-container">
                    <div className="article-header height-auto">
                        <p>
                            <span className="article-header-title">학생 목록({studentList.length})</span>
                        </p>
                        <JoinNavWrap>
                            <OutlinePrimaryBtn type="button" className="contain-icon" onClick={studentDeviceSync} disabled={syncLoading || !deviceList.length || !studentList.length}>
                                <img srcSet={refreshIcon} alt="refresh"/>
                                학생 동기화
                            </OutlinePrimaryBtn>
                            <SolidRedBtn type="button" onClick={removeStudentAll}>
                                일괄 삭제
                            </SolidRedBtn>
                        </JoinNavWrap>
                    </div>
                    <ListContentWrap style={{height: 'calc(100% - 0.5rem - 2.375rem)'}}>
                        <div className="list-one-wrap h100">
                            {studentList.length === 0 ? (<NoDataWithImageText text={NoStudentDataText} />)
                                : <StudentListViewer studentList={studentList}
                                                     studentIdCheckList={studentIdCheckList}
                                                     studentCheckAll={studentCheckAll}
                                                     syncLoading={syncLoading}
                                                     handleStudentAll={handleStudentAll}
                                                     handleStudentCheck={handleStudentCheck}
                                                     removeStudent={removeStudent}/>}

                        </div>
                    </ListContentWrap>
                </article>
            </PageArticleWrap>
            {/*content에 렌더링할 컴포넌트를 전달하여 최신 상태로 리렌더링*/}
            <DefaultModalComponent isOpen={modalProps.isOpen}
                                   content={deviceModalContent()}
                                   button={deviceModalButton()}
                                   type={modalProps.type}
                                   isClose={modalProps.isClose}
                                   title={modalProps.title} />
        </>
      )
    );
}
